module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.878ad71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/roboto/Roboto-Regular.woff
// module id = 0dG7
// module chunks = 0